import { Box, Grid, Typography, Paper } from "@mui/material";

export default function Certification() {
  return (
    <Box
      id="certification"
      sx={{
        px: { xs: 2, sm: 4, md: "250px" },
        py: 8,
        background: "#F7FAFF",
        fontFamily: "Roboto", // ✅ Roboto everywhere
      }}
    >
      {/* ================= HEADING ================= */}
      <Box sx={{ textAlign: "center", mb: 7 }}>
        <Typography
          component="h1"                 // ✅ semantic h1
          sx={{
            fontSize: "32px",             // ✅ 32px
            fontWeight: 700,
            color: "#2d2075",
            letterSpacing: 0.8,
            lineHeight: 1.5,              // ✅ line-height
            mb: 1,
          }}
        >
          Certification
        </Typography>

        {/* UNDERLINE */}
        <Box
          sx={{
            width: 90,
            height: 3,
            backgroundColor: "#2d2075",
            borderRadius: "3px",
            mx: "auto",
            mt: "-4px",
          }}
        />
      </Box>

      <Paper
        elevation={2}
        sx={{
          p: { xs: 3, md: 5 },
          borderRadius: "2px",
          background: "#fff",
          maxWidth: "1900px",
          mx: "auto",
        }}
      >
        <Grid container spacing={6} alignItems="center">
          {/* LEFT IMAGE */}
          <Grid item xs={12} md={5}>
            <Box
              sx={{
                height: { xs: 260, md: 350 },
                borderRadius: "2px",
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#fff",
                boxShadow: "0 0 18px rgba(0,0,0,.10)",
                p: 2,
              }}
            >
              <img
                src="/clients/certificate.jpg"
                alt="ISO 9001:2015 Certification"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  display: "block",
                }}
              />
            </Box>
          </Grid>

          {/* RIGHT TEXT */}
          <Grid item xs={12} md={7}>
            <Typography
              component="p"              
              sx={{
                fontSize: "20px",        
                color: "#444",
                textAlign: "justify",
              }}
            >
              We are certified with <strong>ISO 9001:2015</strong>,
              demonstrating our dedication to global quality standards in
              Manufacturing, Filtration Solutions, and Engineering Services.
              This certification reflects our strong commitment to innovation,
              performance, and customer satisfaction.
            </Typography>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
}
